import React, { useState, useEffect } from 'react';
import logo from '../../assets/logo.png';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from '../../translate.js';
import '../Header/Header.css';
import BandeiraBr from '../../assets/bandeira_br_quadrado.png';
import BandeiraUs from '../../assets/bandeira_en_quadrado.png';
import LogoutIcon from '@mui/icons-material/Logout';
import HistoryIcon from '@mui/icons-material/History';

function Header() {
  const [language, setLanguage] = useState('en');
  const { t } = useTranslation(); 
  const [userJson, setUserJson] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
  let timer;

  if (isMenuOpen) {
  
    timer = setTimeout(() => {
      setIsMenuOpen(false);
    }, 6000); 
  }
  return () => clearTimeout(timer);
}, [isMenuOpen]);



  useEffect(() => {
    const userData = localStorage.getItem("infoUser");
    if (userData) {
      const userDataJson = JSON.parse(userData);
      setUserJson(userDataJson);
    }
  }, []);

  const selecaoIdioma = (idioma) => {
    setLanguage(idioma);
    i18n.changeLanguage(idioma); 
    console.log(idioma);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const logout = () => {
    localStorage.clear();
    setIsMenuOpen(false);
    window.location.reload();
  };

  return (
    <div className='container'> 
      <img className='logoimg' src={logo} alt="Logo"/>
      <h2>{t('first-title')}</h2> 
      
      <img 
        src={BandeiraUs} 
        className='bandeira' 
        alt="ingles" 
        onClick={() => selecaoIdioma('en')} 
        style={{ filter: language === 'pt' ? 'grayscale(100%)' : 'none' }} 
      />
      <img 
        src={BandeiraBr} 
        className='bandeira' 
        alt="portugues" 
        onClick={() => selecaoIdioma('pt')} 
        style={{ filter: language === 'en' ? 'grayscale(100%)' : 'none' }} 
      />
      
      <div>
        <ul>
          <Link className='button-link' to="/login" ><button className='button'>Login</button></Link>
          <Link className='button-link' to="/singup" ><button className='button'>Signup</button></Link> 
        </ul>
      </div>
      {userJson && userJson.nome && (
        <button className='avatar' onClick={toggleMenu}>{userJson.nome.slice(0, 1).toUpperCase()}</button>
      )}
      {userJson && userJson.nome && (
        <div className={`menu ${isMenuOpen ? 'open' : ''}`}>
          <p>{userJson.nome}</p>
        <ul>
          <li><Link to="/component1"><HistoryIcon sx={{ color: '#fff', marginRight:"10px" }}/>{t('planningOrganization')} </Link></li>
          <li><Link to="/component2"><HistoryIcon sx={{ color: '#fff', marginRight:"10px" }}/>{t('comp2and3')} </Link></li>
          <li><Link to="/history"><HistoryIcon sx={{ color: '#fff', marginRight:"10px" }}/> Histórico</Link></li>
          <li onClick={logout}><Link to="/"><LogoutIcon sx={{ color: '#fff', marginRight:"10px" }}/>Logout</Link></li>
        </ul>
      </div>
      )}
    </div>
  );
}

export default Header;
